import styled from 'styled-components';
import { Button } from '~/ui/buttons';
import PenEditIcon from '~/assets/icons/penEdit.svg';

export const EditBtnIcon = styled(PenEditIcon)``;

export const EditBtn = styled(Button)`
  background-color: #F3ECFF;
  color: #9738FF;
  padding: 5px;

  position: absolute;
  top: 5px;
  right: 5px;
  margin: 0;
  
  &:hover {
    color: #FFF;
    svg {
      path {
        fill: #FFF !important;
      }
    }
  }
  &.active {
    background-color: #9845fb
  }
`;
